import { ArrowPathIcon, FingerPrintIcon, QrCodeIcon } from '@heroicons/react/16/solid'
import { aaguid } from '../constants'
import { PasskeyTransport } from '../models/passkey/passkey'
import { UsbIcon } from '../components/usb-icon/usb-icon'
import { NfcIcon } from '../components/nfc-icon/nfc-icon'
import { BluetoothIcon } from '../components/bluetooth/bluetooth'
import { CableIcon } from '../components/cable-icon/index'

export interface AaguidValue {
  name: string
  icon_light: string
  icon_dark: string
}

export const getAaguidData = (aaguidKey: string | null | undefined): AaguidValue | null => {
  if (!aaguidKey || !(aaguidKey in aaguid)) {
    return null
  }
  return aaguid[aaguidKey as keyof typeof aaguid] as AaguidValue
}

export const getAaguidIcon = (transport: PasskeyTransport): JSX.Element | null => {
  switch (transport) {
    case PasskeyTransport.SYNCED:
      return <ArrowPathIcon className="w-3 h-3" />
    case PasskeyTransport.USB:
      return <UsbIcon className="w-3 h-3" />
    case PasskeyTransport.NFC:
      return <NfcIcon className="w-3 h-3" />
    case PasskeyTransport.BLUETOOTH:
      return <BluetoothIcon className="w-3 h-3" />
    case PasskeyTransport.INTERNAL:
      return <FingerPrintIcon className="w-3 h-3" />
    case PasskeyTransport.HYBRID:
      return <QrCodeIcon className="w-3 h-3" />
    case PasskeyTransport.CABLE:
      return <CableIcon className="w-3 h-3" />
    default:
      return null
  }
}
